import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class CreateListFromOrderHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);
    }

    async submitForm(event) {
        let data = await super.submitForm(event);

        window.location.href = data.list_url;
    }
}
